/// <reference types="@types/segment-analytics" />
/// <reference types="@types/intercom-web" />

declare global {
  interface Window {
    analytics: SegmentAnalytics.AnalyticsJS;
    Intercom: Intercom_.IntercomSettings;
  }
}

const TEST_SENDING_ANALYTICS = false; // used for testing sending analytics in development
const LOG_ANALYTICS = true; // used for logging analytics being sent

export const track = (
  eventName: string,
  metadata?: Record<string, unknown>
): void => {
  const fullMetadata = metadata || {};
  if (LOG_ANALYTICS) {
    // eslint-disable-next-line
    console.log(
      `[Analytics] Tracking event name: ${eventName}, with metadata: ${JSON.stringify(
        fullMetadata
      )}`
    );
  }
  if (
    (process.env.NODE_ENV !== "development" &&
      process.env.NODE_ENV !== "test") ||
    TEST_SENDING_ANALYTICS
  ) {
    window.analytics.track(eventName, fullMetadata);
  }
};
